import { render, staticRenderFns } from "./planets-visibility.vue?vue&type=template&id=35367e8c&scoped=true&"
import script from "./planets-visibility.vue?vue&type=script&lang=js&"
export * from "./planets-visibility.vue?vue&type=script&lang=js&"
import style0 from "./planets-visibility.vue?vue&type=style&index=0&id=35367e8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35367e8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VDialog})
